import request from '@/utilities/request';
import { countDown } from '@/utilities/index';

export default {
  initEmailConflictCountdown({ commit, state }) {
    window.clearInterval(state.counter);
    commit('setCounter', null);
    commit('setIsCountDowning', true);
    commit('setCoundownSec', 120);

    const counter = countDown(
      120,
      (sec) => { commit('setCoundownSec', sec); },
      () => { commit('setIsCountDowning', false); },
    );
    commit('setCounter', counter);
  },

  async sendEmailConflictOTP({ commit, state, rootState }) {
    commit('setIsCodeSentFail', false);

    window.clearInterval(state.counter);
    commit('setCounter', null);
    commit('setIsCountDowning', true);
    commit('setCoundownSec', 120);

    const counter = countDown(
      120,
      (sec) => { commit('setCoundownSec', sec); },
      () => { commit('setIsCountDowning', false); },
    );
    commit('setCounter', counter);

    let recaptchaToken = '';
    let siteKey = '';

    try {
      const recaptchaResult = await state.recaptcha.execute('sendEmailConflictOTP');
      recaptchaToken = recaptchaResult.token;
      siteKey = recaptchaResult.siteKey;
    } catch (error) {
      // ignore
    }

    request
      .post('/signin/module.php/tmauth/passwordlesssendcode', {
        recaptchaToken,
        siteKey,
        action_type: 'sign_in',
        email: state.emailAddr,
        locale: rootState.userLang,
      })
      .catch(() => {
        window.clearInterval(counter);
        commit('setCounter', null);
        commit('setIsCountDowning', false);
        commit('setIsCodeSentFail', true);
      });
  },

};
